import {
  Box,
  Button,
  DateField,
  Form,
  HStack,
  SubmitButton,
  TextField,
  useToast,
} from '@medely/ui-kit';
import React from 'react';
import { useAssignmentRequestsForWorkGapForm } from './graphql';
import { IResumeItem } from '@medely/types';
import { useWorkGapMutations, WorkGapFormValuesProps } from './mutations';
import { workGapValidationSchema } from './schema';

type WorkGapFormProps = {
  assignmentId?: number;
  workGap?: IResumeItem;
  isModal?: boolean;
  onSuccess: () => void;
};

export const WorkGapForm = ({
  assignmentId,
  workGap,
  onSuccess,
  isModal = false,
}: WorkGapFormProps) => {
  const { assignmentRequests } = useAssignmentRequestsForWorkGapForm(Number(assignmentId));
  const { addWorkGap, editWorkGap, isLoading } = useWorkGapMutations();
  const toast = useToast();

  const assignment_request_id = !!assignmentRequests?.length ? assignmentRequests[0]?.id : null;

  const handleSubmit = (values: WorkGapFormValuesProps) => {
    const action = workGap ? editWorkGap : addWorkGap;
    const successMessage = workGap
      ? 'Work gap updated successfully'
      : 'Work gap added successfully';
    const errorMessage = workGap ? 'Error updating work gap' : 'Error adding work gap';

    action(
      { values, assignment_request_id },
      {
        onSuccess: () => {
          onSuccess();
          toast.success(successMessage);
        },
        onError: () => {
          toast.error(errorMessage);
        },
      },
    );
  };

  return (
    <Form schema={workGapValidationSchema} handleSubmit={handleSubmit} defaultValues={workGap}>
      <Box testId="work-gap-form-start-date">
        <DateField name="start_date" label="Start date *" />
      </Box>
      <Box testId="work-gap-form-end-date" py={1}>
        <DateField name="end_date" label="End date *" />
      </Box>
      <Box testId="work-gap-form-explanation" pb={1}>
        <TextField name="explanation" label="Work gap explanation *" />
      </Box>
      <HStack pt={1} gap={isModal ? 2 : 0} justifyContent="space-around">
        {isModal && (
          <Button
            fullWidth
            onClick={() => onSuccess()}
            variant="outlined"
            disabled={isLoading}
            testId="work-gap-modal-back-button"
          >
            Back
          </Button>
        )}
        <SubmitButton
          fullWidth
          disabled={isLoading}
          loading={isLoading}
          testId="work-gap-modal-save-button"
        >
          Save
        </SubmitButton>
      </HStack>
    </Form>
  );
};
